// Apps installed outside the stores update themselves before opening (HRTH-198.2): the shell
// looks for a newer signed release (apps/tauri/plugins/update) and, if there is one, this
// shows "Updating" while it downloads. Linux then restarts into it; Android opens the system
// installer over the app, which goes on opening. Anything failing just opens the app.

import { appInvoke } from '../platform'

interface Found {
  version: string
  build: number
  size: number
}

interface Progress {
  done: number
  total: number
}

type Invoke = <T>(cmd: string, args?: Record<string, unknown>) => Promise<T>

function screen(el: HTMLElement, version: string): (p: Progress) => void {
  el.innerHTML = ''
  const box = document.createElement('div')
  box.style.cssText =
    'min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;font-family:system-ui,sans-serif'
  const title = document.createElement('p')
  title.textContent = `Updating hrth to ${version}…`
  const bar = document.createElement('progress')
  bar.style.width = '240px'
  box.append(title, bar)
  el.append(box)
  return (p) => {
    if (p.total > 0) {
      bar.max = p.total
      bar.value = p.done
    }
  }
}

/** Resolves when the app should open: no update, it failed, or (Android) the installer is up. */
export async function updateBeforeOpening(el: HTMLElement, invoke: Invoke = appInvoke): Promise<void> {
  let found: Found | null
  try {
    found = await invoke<Found | null>('plugin:update|check')
  } catch (e) {
    console.info('hrth: not updating:', e)
    return
  }
  if (!found) return
  const show = screen(el, found.version)
  const timer = setInterval(() => {
    invoke<Progress>('plugin:update|progress').then(show, () => undefined)
  }, 250)
  try {
    await invoke('plugin:update|install')
  } catch (e) {
    console.warn('hrth: update failed:', e)
  } finally {
    clearInterval(timer)
    el.innerHTML = ''
  }
}
